import React from 'react'
import Render from 'core/layout/Render'
import api from 'core/api/contentstack'
import { layoutData } from 'core/layout'

const Page = (props: any) => {
  return <Render
    pageComponents={props.result?.shared_components?.components}
    entryUid={props.result?.uid}
    translations={props.translations}
    locale={props.result?.locale} />
}

export async function getStaticProps(context: any) {
  try {
    const [result, layout]: any[] = await Promise.all([
      api.getEntryByUrl("page", `/${context.params.page}`, context.locale, [
        "shared_components.components.featured_products.items",
        "shared_components.components.featured_products.items.color",
        "shared_components.components.featured_products.items.filters",
        "shared_components.components.featured_products.background_color",
        "shared_components.components.featured_recipes.items",
        "shared_components.components.featured_recipes.items.filters",
        "shared_components.components.featured_recipes.items.product.color",
        "shared_components.components.featured_recipes.items.product.filters",
        "shared_components.components.featured_recipes.background_color",
        "shared_components.components.mixed_content_banner.color",
        "shared_components.components.product_banner.product.color",
        "shared_components.components.product_banner.product",
        "shared_components.components.icon_sections.background_color",
        "shared_components.components.logo_showcase.background_color",
        "shared_components.components.categories.items.background_color",
        "shared_components.components.image_list.background",
        "shared_components.components.header_banner.background",
        "shared_components.components.solution_features.background",
        "shared_components.components.featured_recipe.recipe.product.color"
      ]),
      layoutData(api, context.locale),
    ])

    // revalidate: false — permanently cache 404s for unknown slugs.
    // The middleware blocklist handles the bulk of bot probes before they reach
    // here; anything that slips through gets one Contentstack call and is then
    // cached permanently until next deploy. This prevents the ISR re-render
    // storm where revalidate:60 was re-rendering every unique bot URL every minute.
    // Note: withFallback in getEntryByUrl serves stale cache on transient CMS
    // failures, so a clean null here reliably means "no CMS entry for this slug".
    if (!result) return { notFound: true, revalidate: false }

    return {
      props: { layout: true, ...layout, result, seo: result?.seo },
      revalidate: 43200,
    }
  } catch (error: any) {
    // Transient failure (exception escaping withFallback with no stale cache).
    // Use a short revalidate so the page recovers once CMS is available again,
    // rather than permanently caching a 404 for a page that may legitimately exist.
    console.error('[page] getStaticProps error:', error?.message || error)
    return { notFound: true, revalidate: 300 }
  }
}

export async function getStaticPaths() {
  const [pagesEN, pagesFR, pagesCA]: any[] = await Promise.all([
    api.getPages('en-US'),
    api.getPages('fr'),
    api.getPages('en-CA'),
  ])

  const excluded = ['/', '/404', '/where-to-buy', '/offers']
  const mapPages = (pages: any[] | null, locale: string) =>
    (pages || [])
      .filter((p: any) => !excluded.includes(p.url))
      .map((p: any) => ({
        params: { page: p.url.substr(1, p.url.length - 1) },
        locale
      }))

  return {
    paths: [
      ...mapPages(pagesEN, 'en-US'),
      ...mapPages(pagesFR, 'fr'),
      ...mapPages(pagesCA, 'en-CA')
    ],
    fallback: 'blocking'
  };
}

export default Page
